import { render, staticRenderFns } from "./TablesManage.vue?vue&type=template&id=18139de4"
import script from "./TablesManage.vue?vue&type=script&lang=js"
export * from "./TablesManage.vue?vue&type=script&lang=js"
import style0 from "./TablesManage.vue?vue&type=style&index=0&id=18139de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports